import React, { useCallback, useEffect, useState, useRef } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, FlatList} from 'react-native';
import { responsiveFontSize, responsiveHeight, responsiveScreenWidth, responsiveWidth } from 'react-native-responsive-dimensions';
import { useFocusEffect } from '@react-navigation/native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import Svg, {Path} from 'react-native-svg';
import { format } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

import Header from '../components/header';
import { getDataObject } from '../utils/asyncStorageBase';
import ViewCart from '../components/viewCart';
import { LoadDados, LoadWithKey, saveUser } from '../services/firebaseServices';
import colors from '../styles/colors';
import AlertModal from '../components/alertModal';
import Develop from '../components/develop';
import Pix from '../../assets/img/pix.svg';

//notification

import * as Device from 'expo-device';
import * as Notifications from 'expo-notifications';

import { firebaseAuth } from '../../firebase';
import MyText from '../components/MyText';

Notifications.setNotificationHandler({
    handleNotification: async () => ({
      shouldShowAlert: true,
      shouldPlaySound: true,
      shouldSetBadge: true,
    }),
});

const pathPix = "M242.4 292.5c5.4-5.4 14.7-5.4 20.1 0l77 77c14.2 14.2 33.1 22 53.1 22h15.1l-97.1 97.1c-30.3 29.5-79.5 29.5-109.8 0l-97.5-97.4h9.3c20 0 38.9-7.8 53.1-22l76.7-76.7zm20.1-73.6c-6.4 5.5-14.6 5.6-20.1 0l-76.7-76.7c-14.2-15.1-33.1-22-53.1-22h-9.3l97.4-97.44c30.4-30.346 79.6-30.346 109.9 0l97.2 97.14h-15.2c-20 0-38.9 7.8-53.1 22l-77 77zm-149.9-76.2c13.8 0 26.5 5.6 37.1 15.4l76.7 76.7c7.2 6.3 16.6 10.8 26.1 10.8 9.4 0 18.8-4.5 26-10.8l77-77c9.8-9.7 23.3-15.3 37.1-15.3h37.7l58.3 58.3c30.3 30.3 30.3 79.5 0 109.8l-58.3 58.3h-37.7c-13.8 0-27.3-5.6-37.1-15.4l-77-77c-13.9-13.9-38.2-13.9-52.1.1l-76.7 76.6c-10.6 9.8-23.3 15.4-37.1 15.4H80.78l-58.02-58c-30.346-30.3-30.346-79.5 0-109.8l58.02-58.1h31.82z"

const pathRef = '/Category'
const pathRefBusiness = '/Business/Dados'
export default function Home({navigation}) {
    const [business, setBusiness] = useState(null)
    const [category, setCategory] = useState(null)
    const [cart, setCart] = useState([]);
    const [totalCart, setTotalCart] = useState(0)

    //verificar pagamento
    const[cartCredit, setCartCredit] = useState(false)
    const[cartMoney, setCartMoney] = useState(false)
    const[cartPix, setCartPix] = useState(false)

    const [listServices, setListServices] = useState('')

    //alertModal 
    const[open, setOpen] = useState(true);
    const[alertModal, setAlertModal] = useState(false)

    //notification
    const [expoPushToken, setExpoPushToken] = useState('');
    const [notification, setNotification] = useState(false);
    const notificationListener = useRef();
    const responseListener = useRef();


    useFocusEffect(
        useCallback(()=>{ 
            getDataObject('cart').then((value)=> setCart(value));
            if(firebaseAuth.currentUser !== null){
                OneSignal.login(firebaseAuth.currentUser.uid);
                // registerForPushNotificationsAsync().then(token => setExpoPushToken(token));
            }
            return ()=>{}
        },[])
        )
        
    // useEffect(() => {
    //     checkNotification()    

    //     notificationListener.current = Notifications.addNotificationReceivedListener(notification => {
    //       setNotification(notification);
    //     });
    
    //     responseListener.current = Notifications.addNotificationResponseReceivedListener(response => {
          
    //     });
    
    //     return () => {
    //       Notifications.removeNotificationSubscription(notificationListener.current);
    //       Notifications.removeNotificationSubscription(responseListener.current);
    //     };
    //   }, []);

    useEffect(()=>{
        LoadWithKey(pathRef, response => {
            if(response !== null && response !== undefined){
                let limp = response.sort((a,b)=>{
                    if (a.ordem > b.ordem) {
                        return 1;
                      }
                      if (a.ordem < b.ordem) {
                        return -1;
                      }
                      // a must be equal to b
                      return 0;
                }).filter( item => item.active === true)
                setCategory(limp)
            }
        })
        LoadDados(pathRefBusiness, response => setBusiness(response))

    },[])

    useEffect(()=>{
        if(business !== null){
            checkHorario()
            let typeOfService = business.typeOfService.filter(item => item.checked).map(item => item.method);
            let services = '';
            switch(typeOfService.length){
                case 2:
                    services = `${typeOfService[0]} e ${typeOfService[1]}`
                    break;
                case 3:
                    services = `${typeOfService[0]}, ${typeOfService[1]} e ${typeOfService[2]}`
                    break;
                default:
                    services = `${typeOfService}`
                    break;
            }
            setListServices(services);

            business.typeOfPayment.map(item => {
                
                if(item.method === 'Dinheiro' && item.checked === true){
                    setCartMoney(true)
                }else if(item.method === 'Cartão' && item.checked === true){
                    setCartCredit(true)
                }else if(item.method === 'Pix' && item.checked === true){
                    setCartPix(true)
                }else{
                    setCartCredit(false)
                    setCartMoney(false)
                    setCartPix(false)
                }
            })
        }
    },[business])

    useEffect(()=>{
        if(cart !== null){
            let tt = 0;
            cart.map(value => tt += value.total);
            setTotalCart(tt);
            
        }
    },[cart])

    //Notificação
    async function checkNotification(){
        if (Platform.OS === 'android') {
            
            await Notifications.setNotificationChannelAsync('default', {
                name: 'default',
                importance: Notifications.AndroidImportance.MAX,
                vibrationPattern: [0, 250, 250, 250],
                lightColor: '#FF231F7C',
            });
        }
        if (Device.isDevice) {
            const { status: existingStatus } = await Notifications.getPermissionsAsync();
            let finalStatus = existingStatus;
            
            if (existingStatus !== 'granted') {
                const { status } = await Notifications.requestPermissionsAsync();
                finalStatus = status;
            }
            if (finalStatus !== 'granted') {
            alert('Failed to get push token for push notification!');
            return;
          }
        } else {
          alert('Must use physical device for Push Notifications');
        }
    }
    async function registerForPushNotificationsAsync() {
        let token;
        
        if (Device.isDevice) {
            const { status: existingStatus } = await  Notifications.getPermissionsAsync();
            let finalStatus = existingStatus;
            
            if (finalStatus !== 'granted') {
                alert('Failed to get push token for push notification!');
                return;
            }
            token = (await Notifications.getExpoPushTokenAsync()).data;
            let user = {
                token
            }
            saveUser('/User', firebaseAuth.currentUser.uid, user, response => {})
            
        } else {
          alert('Must use physical device for Push Notifications');
        }
      
        return token;
    }

    function renderHeader(){
        return(
            <View style={styles.containerInfo}>
                <View style={styles.horizontal}>
                    <MaterialCommunityIcons name="clock-time-four-outline" size={responsiveFontSize(3)} color="gray" />
                    <MyText style={styles.txtInfo}>{business?.deliveryTime} min</MyText>
                    {cartCredit && (
                        <MaterialCommunityIcons name="credit-card-outline" size={responsiveFontSize(3)} color="gray" />
                    )}
                    {cartMoney && (
                        <MaterialCommunityIcons name="cash" size={responsiveFontSize(4)} color="gray" />
                    )}
                    {cartPix && (
                        <Svg
                            xmlns="http://www.w3.org/2000/svg"
                            height={responsiveFontSize(2)}
                            viewBox="0 0 512 512"
                            >
                            <Path d={pathPix} fill={'gray'} />
                        </Svg>
                        
                    )}
                    {open === false && (<MyText style={styles.closed}>Fechado</MyText>)}
                </View>
                <View style={styles.horizontal}>
                    <MaterialCommunityIcons name="moped" size={responsiveFontSize(3)} color="gray" />
                    {business?.taxaEntrega === "0,00" ? (
                        <MyText style={styles.txtFree}>Entrega grátis</MyText>
                    ) : (
                        <MyText style={styles.txtInfo}>R$ {business?.taxaEntrega}</MyText>
                    )}
                </View>
                <View style={styles.horizontal}>
                    <MaterialCommunityIcons name="room-service-outline" size={responsiveFontSize(3)} color="gray" />
                    <MyText style={styles.txtInfo}>{listServices}</MyText>
                </View>
                <TouchableOpacity style={styles.btnInfo} onPress={()=>{navigation.navigate('Info',{business, listServices})}}>
                    <MaterialCommunityIcons name="information-outline" size={responsiveFontSize(2)} color={colors.red}/>
                </TouchableOpacity>
            </View>
        )
    }

    function renderItem(item){
        return(
            <TouchableOpacity style={styles.btnCategory} 
                onPress={()=>{
                    open === true ?
                    navigation.navigate('CategoryDetail',{item: item, business}) :
                    setAlertModal(true)
                }}>
                <MyText style={styles.txtCategory}>{item.name}</MyText>
                <MaterialCommunityIcons name="arrow-right" size={24} color="gray" />
            </TouchableOpacity>
        )
    }

    function checkHorario() {
        const { horario } = business;
        const dataNow = new Date();
      
        // Define as horas de acordo com o dia da semana atual
        const week = dataNow.getDay();
      
        const todayHorario = horario[week];
        const { from, to, from2, to2, checked } = todayHorario;
      
        const timeNow = format(dataNow, 'HH:mm', { locale: ptBR });
      
        let isOpen = false;
      
        if (checked) {
          if (to !== '00:00' && from !== '00:00' && to2 !== '00:00' && from2 !== '00:00') {
            const isOpenNow = (timeNow >= from && timeNow <= to) || (timeNow >= from2 && timeNow <= to2);
            isOpen = isOpenNow;
          } else {
            isOpen = timeNow >= from && timeNow <= to;
          }
        }
      
        setOpen(isOpen);
    }

    return(
        <View style={styles.container}>
            <Header business={business}/>   
            <FlatList
                data={category}
                keyExtractor={item => item.key}
                renderItem={({item}) => renderItem(item)} 
                ListHeaderComponent={renderHeader()}
            />
            <AlertModal
                visible={alertModal}
                title={'Ah não 😔'}
                msg={'Infelizmente estamos fechados, tente novamente mais tarde ou olhe os nossos horário para ver quando iremos retornar. ⏰'}
                txtBtnCancel={'Não, obrigado'}
                txtBtnConfirm={'Ver horários'}
                callback={(value) => {
                    setAlertModal(false)
                    if(value === 'confirmar'){
                        navigation.navigate('Info',{business, listServices})
                    }
                }}
            />
            <Develop/>
            {cart !== null && open === true && (
                <ViewCart numCart={cart?.length} total={totalCart} navigation={navigation}/>
            )}
        </View>
    )
}

const styles = StyleSheet.create({ 
    container:{
        flex: 1,
    },
    horizontal: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: responsiveFontSize(3),
    },
    containerInfo: {
        width: responsiveFontSize(49),
        backgroundColor: '#fff',
        paddingTop: responsiveFontSize(3),
        marginBottom: responsiveFontSize(3),
        alignSelf: 'center'
    },
    txtInfo: {
        color: 'gray',
        marginHorizontal: responsiveFontSize(2),
        fontSize: responsiveFontSize(1.6)
    },
    txtFree: {
        color: colors.green,
        marginHorizontal: responsiveFontSize(2),
        fontSize: responsiveFontSize(1.6)
    },
    btnCategory: {
        backgroundColor: '#fff',
        flexDirection: 'row',
        width: responsiveFontSize(44),
        height: responsiveFontSize(8),
        borderRadius: 5,
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: responsiveFontSize(3),
        marginBottom: responsiveFontSize(1)
    },
    txtCategory: {
        fontSize: responsiveFontSize(1.8),
        fontWeight: 'bold'
    },
    //infor
    btnInfo: {
        alignSelf: 'flex-end',
        paddingHorizontal: responsiveFontSize(2),
        paddingVertical: responsiveFontSize(0.5),
        marginRight: responsiveFontSize(3),
        borderRadius: responsiveFontSize(0.5),
        borderWidth: responsiveFontSize(0.1),
        borderColor: colors.red,
        marginBottom: responsiveFontSize(2)
    },
    closed: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: responsiveFontSize(1.6),
        marginLeft: 'auto',
        backgroundColor: colors.gray,
        paddingHorizontal: responsiveFontSize(1),
        paddingVertical: responsiveFontSize(0.5),
        borderRadius: responsiveFontSize(0.5)
    }
})

